// ─── Temporary Level 1 data (city-level summary) ─────────────────────────────
export const TEMP_STATE_OF_USE_LEVEL1_DATA = [
  {
    id: "bangalore",
    city: "Bangalore",
    numberOfVehicles: 6,
    timeSpentDischargingPercent: 6,
    timeSpentChargingPercent: 6,
    timeSpentNonOperationalPercent: 6,
  },
  {
    id: "mangalore",
    city: "Mangalore",
    numberOfVehicles: 4,
    timeSpentDischargingPercent: 4,
    timeSpentChargingPercent: 4,
    timeSpentNonOperationalPercent: 4,
  },
  {
    id: "mumbai",
    city: "Mumbai",
    numberOfVehicles: 3,
    timeSpentDischargingPercent: 3,
    timeSpentChargingPercent: 3,
    timeSpentNonOperationalPercent: 3,
  },
  {
    id: "surat",
    city: "Surat",
    numberOfVehicles: 2,
    timeSpentDischargingPercent: 2,
    timeSpentChargingPercent: 2,
    timeSpentNonOperationalPercent: 2,
  },
  {
    id: "delhi",
    city: "Delhi",
    numberOfVehicles: 2,
    timeSpentDischargingPercent: 2,
    timeSpentChargingPercent: 2,
    timeSpentNonOperationalPercent: 2,
  },
];

// ─── Temporary Level 2 data (vehicle-level detail) ───────────────────────────
const TEMP_VEHICLES_BY_CITY = {
  bangalore: [
    {
      id: "KA-01-AB-1234",
      licensePlateNumber: "KA-01-AB-1234",
      status: "inactive",
      timeSpentDischargingPercent: 38,
      timeSpentChargingPercent: 32,
      timeSpentNonOperationalPercent: 8,
      city: "Bangalore",
      state: "Karnataka",
      depot: "Bangalore Central Depot",
    },
    {
      id: "KA-01-AB-5678",
      licensePlateNumber: "KA-01-AB-5678",
      status: "active",
      timeSpentDischargingPercent: 35,
      timeSpentChargingPercent: 30,
      timeSpentNonOperationalPercent: 10,
      city: "Bangalore",
      state: "Karnataka",
      depot: "Bangalore North Depot",
    },
    {
      id: "KA-01-CD-1111",
      licensePlateNumber: "KA-01-CD-1111",
      status: "active",
      timeSpentDischargingPercent: 40,
      timeSpentChargingPercent: 28,
      timeSpentNonOperationalPercent: 12,
      city: "Bangalore",
      state: "Karnataka",
      depot: "Bangalore South Depot",
    },
  ],

  mangalore: [
    {
      id: "KA-19-AB-2222",
      licensePlateNumber: "KA-19-AB-2222",
      status: "active",
      timeSpentDischargingPercent: 42,
      timeSpentChargingPercent: 35,
      timeSpentNonOperationalPercent: 8,
      city: "Mangalore",
      state: "Karnataka",
      depot: "Mangalore Port Depot",
    },
    {
      id: "KA-19-CD-3333",
      licensePlateNumber: "KA-19-CD-3333",
      status: "inactive",
      timeSpentDischargingPercent: 38,
      timeSpentChargingPercent: 30,
      timeSpentIdlePercent: 22,
      timeSpentNonOperationalPercent: 10,
      city: "Mangalore",
      state: "Karnataka",
      depot: "Mangalore City Depot",
    },
  ],

  mumbai: [
    {
      id: "MH-01-AB-4444",
      licensePlateNumber: "MH-01-AB-4444",
      status: "active",
      timeSpentDischargingPercent: 36,
      timeSpentChargingPercent: 34,
      timeSpentNonOperationalPercent: 10,
      city: "Mumbai",
      state: "Maharashtra",
      depot: "Mumbai Central Depot",
    },
    {
      id: "MH-01-CD-5555",
      licensePlateNumber: "MH-01-CD-5555",
      status: "active",
      timeSpentDischargingPercent: 40,
      timeSpentChargingPercent: 32,
      timeSpentNonOperationalPercent: 10,
      city: "Mumbai",
      state: "Maharashtra",
      depot: "Mumbai Western Depot",
    },
  ],

  surat: [
    {
      id: "GJ-05-AB-6666",
      licensePlateNumber: "GJ-05-AB-6666",
      status: "active",
      timeSpentDischargingPercent: 44,
      timeSpentChargingPercent: 30,
      timeSpentNonOperationalPercent: 8,
      city: "Surat",
      state: "Gujarat",
      depot: "Surat Industrial Depot",
    },
  ],

  delhi: [
    {
      id: "DL-01-AB-7777",
      licensePlateNumber: "DL-01-AB-7777",
      status: "active",
      timeSpentDischargingPercent: 45,
      timeSpentChargingPercent: 35,
      timeSpentNonOperationalPercent: 8,
      city: "Delhi",
      state: "Delhi",
      depot: "Delhi NCR Depot",
    },
  ],
};

// ─── Level 1 column definitions ───────────────────────────────────────────────
export const STATE_OF_USE_LEVEL1_COLUMN_ORDER = [
  "city",
  "numberOfVehicles",
  "timeSpentDischargingPercent",
  "timeSpentChargingPercent",
  "timeSpentNonOperationalPercent",
  "actions",
];

export const STATE_OF_USE_LEVEL1_COLUMNS_CONFIG = {
  city: {
    title: "City",
    headerLabel: "City",
    dataIndex: "city",
    key: "city",
    width: 250,
    fixed: "left",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
  },
  numberOfVehicles: {
    title: "Number of Vehicles",
    headerLabel: "Number of Vehicles",
    dataIndex: "numberOfVehicles",
    key: "numberOfVehicles",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 250,
  },
  timeSpentDischargingPercent: {
    title: "Time Spent Discharging (%)",
    headerLabel: "Time Spent Discharging (%)",
    dataIndex: "timeSpentDischargingPercent",
    key: "timeSpentDischargingPercent",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 250,
  },
  timeSpentChargingPercent: {
    title: "Time Spent Charging (%)",
    headerLabel: "Time Spent Charging (%)",
    dataIndex: "timeSpentChargingPercent",
    key: "timeSpentChargingPercent",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 250,
  },
  timeSpentNonOperationalPercent: {
    title: "Time Spent in Non-Operational State(%)",
    headerLabel: "Time Spent in Non-Operational State(%)",
    dataIndex: "timeSpentNonOperationalPercent",
    key: "timeSpentNonOperationalPercent",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 300,
  },
  actions: {
    title: "Actions",
    headerLabel: "Actions",
    dataIndex: "actions",
    key: "actions",
    valueRenderingType: "details-link",
    fixed: "right",
    width: 200,
  },
};

// ─── Level 2 column definitions ───────────────────────────────────────────────
export const STATE_OF_USE_LEVEL2_COLUMN_ORDER = [
  "licensePlateNumber",
  "timeSpentDischargingPercent",
  "timeSpentChargingPercent",
  "timeSpentNonOperationalPercent",
  "city",
  "state",
  "depot",
];

export const STATE_OF_USE_LEVEL2_COLUMNS_CONFIG = {
  licensePlateNumber: {
    title: "Bus Number",
    headerLabel: "Bus Number",
    dataIndex: "licensePlateNumber",
    key: "licensePlateNumber",
    valueRenderingType: "vehicle-license-plate",
    width: 250,
    fixed: "left",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
  },

  
  timeSpentDischargingPercent: {
    title: "Time Spent Discharging (%)",
    headerLabel: "Time Spent Discharging (%)",
    dataIndex: "timeSpentDischargingPercent",
    key: "timeSpentDischargingPercent",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 220,
  },
  
  timeSpentChargingPercent: {
    title: "Time Spent Charging (%)",
    headerLabel: "Time Spent Charging (%)",
    dataIndex: "timeSpentChargingPercent",
    key: "timeSpentChargingPercent",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 200,
  },
  
  timeSpentNonOperationalPercent: {
    title: "Time Spent in Non-Operational State(%)",
    headerLabel: "Time Spent in Non-Operational State(%)",
    dataIndex: "timeSpentNonOperationalPercent",
    key: "timeSpentNonOperationalPercent",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 300,
  },
  city: {
    title: "City",
    headerLabel: "City",
    dataIndex: "city",
    key: "city",
    width: 250,
    sorter: true,
    sortDirections: ["ascend", "descend", "ascend"],
  },

  state: {
    title: "State",
    headerLabel: "State",
    dataIndex: "state",
    key: "state",
    width: 250,
    sorter: true,
    sortDirections: ["ascend", "descend", "ascend"],
  },

  depot: {
    title: "Depot",
    headerLabel: "Depot",
    dataIndex: "depot",
    key: "depot",
    width: 250,
    sorter: true,
    sortDirections: ["ascend", "descend", "ascend"],
  },
};
// ═══════════════════════════════════════════════════════════════════════════════
// STATE-OF-USE TREND DRILL-DOWN (project-level → vehicle detail)
// ═══════════════════════════════════════════════════════════════════════════════

// ─── Temporary Level 1 data for Trend (project-level summary) ─────────────────
export const TEMP_STATE_OF_USE_TREND_LEVEL1_DATA = [
  {
    id: "314-kWh",
    project: "314 kWh",
    numberOfVehicles: 6,
    timeSpentDischargingPercent: 6,
    timeSpentChargingPercent: 6,
    timeSpentNonOperationalPercent: 6,
  },
  {
    id: "112-kWh",
    project: "112 kWh",
    numberOfVehicles: 4,
    timeSpentDischargingPercent: 4,
    timeSpentChargingPercent: 4,
    timeSpentNonOperationalPercent: 4,
  },
  {
    id: "2210-kWh",
    project: "2210 kWh",
    numberOfVehicles: 3,
    timeSpentDischargingPercent: 3,
    timeSpentChargingPercent: 3,
    timeSpentNonOperationalPercent: 3,
  },
  {
    id: "891-kWh",
    project: "891 kWh",
    numberOfVehicles: 2,
    timeSpentDischargingPercent: 2,
    timeSpentChargingPercent: 2,
    timeSpentNonOperationalPercent: 2,
  },
  {
    id: "4510-kWh",
    project: "4510 kWh",
    numberOfVehicles: 2,
    timeSpentDischargingPercent: 2,
    timeSpentChargingPercent: 2,
    timeSpentNonOperationalPercent: 2,
  },
];

// ─── Level 1 column definitions for Trend (project instead of city) ────────────
export const STATE_OF_USE_TREND_LEVEL1_COLUMN_ORDER = [
  "project",
  "numberOfVehicles",
  "timeSpentDischargingPercent",
  "timeSpentChargingPercent",
  "timeSpentNonOperationalPercent",
  "actions",
];

export const STATE_OF_USE_TREND_LEVEL1_COLUMNS_CONFIG = {
  project: {
    title: "Project",
    headerLabel: "Project",
    dataIndex: "project",
    key: "project",
    width: 250,
    fixed: "left",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
  },
  numberOfVehicles: {
    title: "Number of Vehicles",
    headerLabel: "Number of Vehicles",
    dataIndex: "numberOfVehicles",
    key: "numberOfVehicles",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 250,
  },
  timeSpentDischargingPercent: {
    title: "Time Spent Discharging (%)",
    headerLabel: "Time Spent Discharging (%)",
    dataIndex: "timeSpentDischargingPercent",
    key: "timeSpentDischargingPercent",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 250,
  },
  timeSpentChargingPercent: {
    title: "Time Spent Charging (%)",
    headerLabel: "Time Spent Charging (%)",
    dataIndex: "timeSpentChargingPercent",
    key: "timeSpentChargingPercent",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 250,
  },

  timeSpentNonOperationalPercent: {
    title: "Time Spent in Non-Operational State(%)",
    headerLabel: "Time Spent in Non-Operational State(%)",
    dataIndex: "timeSpentNonOperationalPercent",
    key: "timeSpentNonOperationalPercent",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 300,
  },
  actions: {
    title: "Actions",
    headerLabel: "Actions",
    dataIndex: "actions",
    key: "actions",
    valueRenderingType: "details-link",
    fixed: "right",
    width: 200,
  },
};

// ─── Trend data fetch functions (temporary — replace with real API calls) ──────

export const getStateOfUseTrendLevel1Data = async (_selectedDataPoint, _pageNumber, _sortBy) => {
  return {
    data: TEMP_STATE_OF_USE_TREND_LEVEL1_DATA,
    total: TEMP_STATE_OF_USE_TREND_LEVEL1_DATA.length,
  };
};

// Reuse existing city vehicle data for the Trend Level 2
export const getStateOfUseTrendLevel2Data = async (_level2Record, _pageNumber, _sortBy) => {
  const vehicles = TEMP_VEHICLES_BY_CITY.bangalore;
  return {
    data: vehicles,
    total: vehicles.length,
  };
};

// ─── Trend table config builders ──────────────────────────────────────────────

export const getStateOfUseTrendLevel1TableConfig = () => ({
  title: () => "State-of-Use",
  tableColumnsConfig: STATE_OF_USE_TREND_LEVEL1_COLUMNS_CONFIG,
  tableColumnOrder: STATE_OF_USE_TREND_LEVEL1_COLUMN_ORDER,
  emptyMessage: "No data available for the selected period",
});

export const getStateOfUseTrendLevel2TableConfig = () => ({
  title: () => "Vehicles Affected",
  tableColumnsConfig: STATE_OF_USE_LEVEL2_COLUMNS_CONFIG,
  tableColumnOrder: STATE_OF_USE_LEVEL2_COLUMN_ORDER,
  emptyMessage: "No vehicles found for the selected project",
});

// ─── Data fetch functions (temporary — replace with real API calls) ────────────

export const getStateOfUseLevel1Data = async (_selectedDataPoint, _pageNumber, _sortBy) => {
  return {
    data: TEMP_STATE_OF_USE_LEVEL1_DATA,
    total: TEMP_STATE_OF_USE_LEVEL1_DATA.length,
  };
};

export const getStateOfUseLevel2Data = async (level2Record, _pageNumber, _sortBy) => {
  const cityKey = (level2Record?.city || "bangalore").toLowerCase();
  const vehicles = TEMP_VEHICLES_BY_CITY[cityKey] || TEMP_VEHICLES_BY_CITY.bangalore;
  return {
    data: vehicles,
    total: vehicles.length,
  };
};

// ─── Table config builders ────────────────────────────────────────────────────

export const getStateOfUseLevel1TableConfig = () => ({
  title: (dataPoint) =>
    `${dataPoint?.selectedItemLabel || "All"}: ${dataPoint?.project || ""}`,
  tableColumnsConfig: STATE_OF_USE_LEVEL1_COLUMNS_CONFIG,
  tableColumnOrder: STATE_OF_USE_LEVEL1_COLUMN_ORDER,
  emptyMessage: "No data available for the selected period",
});

export const getStateOfUseLevel2TableConfig = () => ({
  title: () => "Vehicles Affected",
  tableColumnsConfig: STATE_OF_USE_LEVEL2_COLUMNS_CONFIG,
  tableColumnOrder: STATE_OF_USE_LEVEL2_COLUMN_ORDER,
  emptyMessage: "No vehicles found for the selected location",
});
